
define('Tavano.TT_GA4.Integration.Shopping.Sync'
	, [
        'jQuery'
	]
	, function (
        jQuery
	) {
		'use strict';


		var TavanoTT_GA4IntegrationShoppingSync = {

            ADDTOCART_SOURCE:{
                QUICK_PDP: 'QUICK_PDP',
                FULL_PDP: 'FULL_PDP',
                PLP: 'PLP',
                QUICK_ADD_TO_CART: 'QUICK_ADD_TO_CART',
                UNKNOWN: 'UNKNOWN'
            },

            PRODUCT_VIEW_SOURCE:{
                QUICK_PDP: 'QUICK_PDP',
                FULL_PDP: 'FULL_PDP',
                QUICK_ADD_TO_CART: 'QUICK_ADD_TO_CART',
                UNKNOWN: 'UNKNOWN'
            },


            getDataLayer: function () {
                return window.dataLayer || [];
            },

            pushToDataLayer: function(data) {
                var tracker = this.getDataLayer();
    
                tracker.push(data);
            },
            trackProductViewGA4: function (container, quickAddLine) {

                /** @type {PDPComponent} */
                var pdpComponent = container.getComponent('PDP');
                /** @type {EnvironmentComponent} */
                var environmentComponent = container.getComponent('Environment');


                var session = environmentComponent.getSession();
                var currencyCode = session.currency.code;

                var line = pdpComponent.getItemInfo();

                var itemData = {};

                if(line){
                    var onlinePrice = line && line.item && line.item.onlinecustomerprice_detail && line.item.onlinecustomerprice_detail.onlinecustomerprice || '';

                    var isInModal = container.getLayout().getCurrentView().inModal;
    
                    itemData = {
                            product_view_source: isInModal ? this.PRODUCT_VIEW_SOURCE.QUICK_PDP : this.PRODUCT_VIEW_SOURCE.FULL_PDP,
                            currency: currencyCode,
                            value: onlinePrice,
                            item: [{
                                item_id: line && line.item && line.item.itemid || '',
                                item_name: line && line.item && line.item.storedisplayname2 || '',
                                price: onlinePrice,
                                currency: currencyCode
                            }]
                    };
    
                    console.log('TT_GA4_view_item', itemData);
                        
                }else if(quickAddLine){
                    console.log('TT_GA4_view_item', 'Quick Add');

                    var onlinePrice = quickAddLine && quickAddLine.rate || '';
                    var itemName = quickAddLine && quickAddLine.item && quickAddLine.item.extras && quickAddLine.item.extras.storedisplayname2 || '';

                    itemData = {
                        product_view_source: this.PRODUCT_VIEW_SOURCE.QUICK_ADD_TO_CART,
                        currency: currencyCode,
                        value: onlinePrice,
                        item: [{
                            item_id: quickAddLine && quickAddLine.item && quickAddLine.item.itemid || '',
                            item_name: itemName,
                            price: onlinePrice,
                            currency: currencyCode
                        }]
                    };
                }

                this.pushToDataLayer({
                    event: 'TT_GA4_view_item',
                    data: {
                        data: itemData
                    }
                });

            },

            trackAddToCartGA4: function (container, lineAdded, quantity) {

                /** @type {EnvironmentComponent} */
                var environmentComponent = container.getComponent('Environment');
                /** @type {CartComponent} */
                var cartComponent = container.getComponent('Cart');

                var add_to_cart_source = this.getAddToCartSource(container);


                var self = this;

                cartComponent.getLines().then(function (lines) {


                    var itemAdded = lineAdded && lineAdded.line && lineAdded.line.internalid || '';
                    var itemObject = {};

                    var session = environmentComponent.getSession();
    
                    // ---------------------------
                    // Currency
                    // ---------------------------
                    var currencyCode = session.currency.code;

                    _.each(lines, function (line, lineIndex) {

                        var lastItemAdded = line && line.internalid;

                        if(itemAdded == lastItemAdded){
                            itemObject['item_id'] = line && line.item && line.item.itemid || '';
                            var itemName = line && line.item && line.item.extras && line.item.extras.storedisplayname2 || '';
                            itemObject['item_name'] = itemName;
                            itemObject['quantity'] = quantity;
                            itemObject['price'] = line && line.rate || '';
                            itemObject['currency'] = currencyCode;

                            
                            if(add_to_cart_source == self.ADDTOCART_SOURCE.QUICK_ADD_TO_CART){
                                self.trackProductViewGA4(container, line);
                            }

                        }

                    })

                    var total = quantity * itemObject.price;
                    total = total.toFixed(2);

                    var itemData = {
                        currency: currencyCode,
                        value: total,
                        item: [itemObject],
                        add_to_cart_source: add_to_cart_source
                    };

                    console.log('TT_GA4_add_to_cart', itemData);

                    self.pushToDataLayer({
                        event: 'TT_GA4_add_to_cart',
                        data: {
                            itemData
                        }
                    });


                });


            },
            getAddToCartSource: function (container){

                /** @type {PDPComponent} */
                var pdpComponent = container.getComponent('PDP');

                var plpComponent = container.getComponent('PLP');

                
                
                var source = this.ADDTOCART_SOURCE.UNKNOWN;

                if(pdpComponent){

                    var line = pdpComponent.getItemInfo();

                    if(line){
                        var isInModal = container.getLayout().getCurrentView().inModal;

                        if(isInModal){
                            source = this.ADDTOCART_SOURCE.QUICK_PDP;
                        }else{
                            source = this.ADDTOCART_SOURCE.FULL_PDP;
                        }
                    }

                }

                if(plpComponent){
                    var items = plpComponent.getItemsInfo();
                    if(items && items.length > 0){
                        source = this.ADDTOCART_SOURCE.PLP;
                    }
                }

                var quickAddElement = jQuery('[data-view="QuickAddView"]');

                if(quickAddElement && quickAddElement.length > 0){
                    source = this.ADDTOCART_SOURCE.QUICK_ADD_TO_CART;

                }

                return source; 
            }

		}

		return TavanoTT_GA4IntegrationShoppingSync;
	});
